<template>
  <div class="page-5-wrapper">
    <img class="bg" :src="source('page-5-bg')" alt="" draggable="false">
  </div>
</template>

<script>
import key from "@/api/key";

export default {
  name: 'page-5',
  components: { },
  data() {
    return {
    }
  },
  methods: {
    source(name) {
      return key.getByName(key.HOME, name).fileUrl
    },
  },
  mounted() {

  }
}
</script>

<style scoped lang="scss">
.page-5-wrapper {
  position: relative;
  width: 100vw;
  height: 56.25vw;
  overflow: hidden;

}
</style>
